import React from 'react';

export const FdAddressField = (props: FdAddressFieldProps) => {
  const { record } = props;
  return (
    <div>
      <div>{record.address}</div>
      <div>{record.addressDetail}</div>
    </div>
  );
}

type FdAddressFieldProps = {
  record: {
    address: string;
    addressDetail: string;
  }
}